import React, {useEffect, useState} from 'react';
import getChannels from "../../../actions/getChannels";
import ZaloPersonalApi from "../../../api/zalo-personal.api";
import './ModalSearchZalo.sass';
import {useLocation} from "react-router-dom";
import { AiOutlineUserAdd, AiOutlineMessage } from "react-icons/ai"
import updateChatNotification from "../../../actions/updateChatNotification";
import { Button, Avatar, Card, Form, Row, Col, Modal, Select, Input, message } from 'antd';
const { Meta } = Card;

const ModalSearchZalo = React.memo((props) => {
    const {showModal, setShowModal} = props;
    const [channelLists, setChannelLists] = useState([]);
    const [selectedChannel, setSelectedChannel] = useState(null);
    const [isSendFriendRequest, setIsSendFriendRequest] = useState(false);
    const [zaloInfo, setZaloInfo] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingSendFriendRequest, setLoadingSendFriendRequest] = useState(false);
    const location = useLocation();

    const [form] = Form.useForm();

    useEffect(() => {
        getChannels().then(res => {
            let channels = res.data.channels;
            let oa = channels.filter(e => e.source === 'zalo_personal');
            let channelLists = oa.map(channel => ({value: channel.socialChanelId, label: channel.nameApp}));
            setChannelLists(channelLists);
        }).catch(err => console.log(err));
    }, []);


    const handleChangeChannel = (channelId) => {
        setSelectedChannel(channelId);
    };

    

    const sendFriendRequest = async () => {
        setLoadingSendFriendRequest(true);
        const payload = {
            channel_id: selectedChannel,
            uid: zaloInfo?.uid
        }

        const res = await ZaloPersonalApi.sendFriendRequest(payload);

        const result = res.data;

        if(!result.error){
            console.log({data: result.data})
            message.success('Gửi kết bạn thành công!');
            setLoadingSendFriendRequest(false)
            return;
        }

        setLoadingSendFriendRequest(false)
        message.warning(result.message);
    }

    const handleRouteRoom = async (room) => {
        if(room && room._id){
            let elmRoom = document.getElementsByClassName('room');
            for await (let item of elmRoom) {
                item.classList.remove('room-active')
            }

            const target = `/room/${room._id}`;
            if (location.pathname !== target){
                window.location.href = target;
                // await history.replace(target);
            }
            await updateChatNotification(room._id).then().catch(err => console.log(err));
        }
    }

    const sendMessageByUser = async () => {
        const payload = {
            channel_id: selectedChannel,
            uid: zaloInfo?.uid
        }

        const res = await ZaloPersonalApi.sendMessageByUser(payload);

        const result = res.data;

        if(!result.error){
            console.log({data: result.data})
            handleRouteRoom(result.data);
            return;
        }

        message.warning(result.message);
    }

    const getListAction = () => {
        let lists = [];

        if(isSendFriendRequest){
            lists.push(<Button loading={loadingSendFriendRequest} type="primary" onClick={() => sendFriendRequest()} key="add_friend"><AiOutlineUserAdd style={{ marginRight: '5px' }} size="16"/> Kết bạn </Button>)
        }

        lists.push(<Button type="primary" onClick={() => sendMessageByUser()} key="message"><AiOutlineMessage style={{ marginRight: '5px' }} size="16"/> Gửi tin nhắn</Button>)

        return lists;
    }

    const onSubmit = async (values) => {
        setLoading(true);
        const res = await ZaloPersonalApi.searchByPhone(values);

        const result = res.data;

        if(!result.error){
            console.log({data: result.data})
            setZaloInfo(result.data.search)
            setIsSendFriendRequest(result.data.is_send_friend_request);
            setLoading(false);
            return;
        }

        setLoading(false);
        setZaloInfo(null)
        message.warning(result.message);
    }

    return (
        <Modal
            open={showModal}
            id="modal-search-zalo"
            title="Tìm kiếm người dùng Zalo"
            onCancel={() => setShowModal(false)}
            width={400}
            footer={null}
            confirmLoading={loading}
            centered>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={onSubmit} // Khi submit form
                    >
                    <Row style={{ marginTop: '20px' }}>
                        <Col span={24}>
                            <Form.Item name="channel_id" rules={[{required: true, message: 'Bạn chưa chọn kênh Zalo'}]}>
                                <Select
                                    value={selectedChannel}
                                    onChange={handleChangeChannel}
                                    placeholder={`Chọn kênh zalo`}
                                    options={channelLists}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={16}>
                            <Form.Item name="phone" rules={[{required: true, message: 'Bạn chưa nhập số điện thoại'}]}>
                                <Input placeholder="Nhập số điện thoại tìm kiếm"></Input>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item className="text-right">
                                <Button loading={loading} type="primary" htmlType="submit">Tìm kiếm</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                    {zaloInfo && (
                        <Row className="zalo-info">
                            <Card
                                style={{ width: 400 }}
                                cover={
                                <img
                                    alt="example"
                                    src={zaloInfo.cover}
                                />}
                                actions={getListAction()}
                            >
                                <Meta
                                    avatar={<Avatar style={{ width: 70, height: 70 }} src={zaloInfo.avatar} />}
                                    title={zaloInfo.zalo_name}
                                    description=""
                                />
                            </Card>
                        </Row>
                    )}
                </Form>
        </Modal>
    );
});

export default ModalSearchZalo;
